<!-- =========================================================================================
  File Name: addScheduleSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4 style="word-break: normal;">{{ Object.entries(this.data).length === 0 ? "ADD" : "UPDATE" }} SCHEDULE DETAILS</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <div class="flex">
          <vs-checkbox v-model="ExistingSchedule" @change="excheck(ExistingSchedule)">Choose existing Student</vs-checkbox>
          <vs-checkbox v-model="NewSchedule" @change="newcheck(NewSchedule)">Add New</vs-checkbox>
        </div>
        <vs-select v-if="ExistingSchedule" v-model="ScheduleModel" autocomplete label="Select An Existing Schedule" class="mt-5 w-full">
          <vs-select-item v-for="schedule in schedules" :key="schedule.id" :value="schedule" :text="schedule.name"/>
        </vs-select>
<!--        {{ScheduleModel}}-->
          <div v-if="NewSchedule">
            <!-- NAME -->
            <vs-input label="Schedule Name" v-model="dataName" class="mt-5 w-full" name="item-name"
                      v-validate="'required'"/>

            <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
            <div class="slot-fields" v-for="(daydata, dayindex ) in currrent_schedule.dates" :key="dayindex">
              {{ dayindex }}
              <div v-for="(getdata,skey) in daydata" :key="skey">

                <flat-pickr v-model="key_id[getdata.start_time_model]" :config="configdateTimePicker" class="picker"
                            name="start_time" placeholder="Start time"/>
                <flat-pickr v-model="key_id[getdata.end_time_model]" :config="configdateTimePicker" class="picker"
                            name="end_time" placeholder="End time"/>

              </div>

            <div v-if="day.length > 0" class="slot-actions pr-2 mt-1 " style="float:right">
                <!--            {{dayindex.length}}-->
                <vs-button color="primary" size="small" class="mr-1"
                           @click.native="inputRemove(dayindex)">
                  <feather-icon icon="MinusIcon" svgClasses="h-2 w-2"/>
                </vs-button>
                <vs-button color="primary" size="small"
                           @click.native="inputAdd(dayindex)">
                  <feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/>
                </vs-button>

          </div>


            </div>

          </div>
      </div>

    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import vSelect from 'vue-select'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moduleDataList from '@/store/data-list/moduleDataList.js'


export default {
  props: {
    isCameraScheduleSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },

  components: {
    'v-select': vSelect,
    VuePerfectScrollbar,
    flatPickr,
    moduleDataList

  },
  data () {

    return {
      ExistingSchedule: true,
      NewSchedule: false,
      ScheduleModel: null,

      key_id: {'monday-0-starttime': ''},
      currrent_schedule:
        {
          'id': null,
          'name': 'first schedule',
          'dates': {
            Monday: [
              {
                'start_time': '',
                'end_time': '',
                'start_time_model': 'monday-0-starttime',
                'end_time_model': 'monday-0-endtime'
              }
            ],
            Tuesday: [
              {
                'start_time': '11:55 AM',
                'end_time': '11:55 AM',
                'start_time_model': 'tuesday-0-starttime',
                'end_time_model': 'tuesday-0-endtime'
              }
            ],
            Wednesday: [
              {
                'start_time': '11:55 AM',
                'end_time': '11:55 AM',
                'start_time_model': 'wednesday-0-starttime',
                'end_time_model': 'wednesday-0-endtime'
              }
            ],
            Thursday: [
              {
                'start_time': '11:55 AM',
                'end_time': '11:55 AM',
                'start_time_model': 'thursday-0-starttime',
                'end_time_model': 'thursday-0-endtime'
              }
            ],
            Friday: [
              {
                'start_time': '11:55 AM',
                'end_time': '11:55 AM',
                'start_time_model': 'friday-0-starttime',
                'end_time_model': 'friday-0-endtime'
              }
            ],
            Saturday: [
              {
                'start_time': '11:55 AM',
                'end_time': '11:55 AM',
                'start_time_model': 'saturday-0-starttime',
                'end_time_model': 'saturday-0-endtime'
              }
            ],
            Sunday: [
              {
                'start_time': '11:55 AM',
                'end_time': '11:55 AM',
                'start_time_model': 'sunday-0-starttime',
                'end_time_model': 'sunday-0-endtime'
              }
            ]
          }

        },


      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: 'H:i',
        time_24hr: false,
        altInput: true,
        dateFormat: 'H:i'
      },
      dataId: null,
      dataName: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {

    isCameraScheduleSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.papulateDefaultTimeValues(this.data)

      } else {

        const {
          id

        } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id

        this.ScheduleModel = ''
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    schedules () {
      return this.$store.state.dataList.schedules
    },
    isSidebarActiveLocal: {
      get () {
        return this.isCameraScheduleSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    excheck (val) {
      this.NewSchedule = !val
    },
    newcheck (val) {
      this.ExistingSchedule = !val
    },
    papulateTimeValues (sdata) {
      this.currrent_schedule.dates = sdata.dates
      for (const index in this.currrent_schedule.dates) {

        // console.log(Object.keys(this.key_id).length);
        for (let i = 0; i < Object.keys(this.key_id).length; i++) {
          const start_time_index = `${index  }-${  i  }-starttime`
          const end_time_index = `${index  }-${  i  }-endtime`

          if (typeof (this.currrent_schedule.dates[index][i]) !== 'undefined') {
            this.key_id[start_time_index] = this.currrent_schedule.dates[index][i].start_time
            this.key_id[end_time_index] = this.currrent_schedule.dates[index][i].end_time


          }

        }


      }
    },
    papulateDefaultTimeValues (sdata) {

      this.currrent_schedule.dates = {
        Monday: [
          {
            'start_time': '',
            'end_time': '',
            'start_time_model': 'monday-0-starttime',
            'end_time_model': 'monday-0-endtime'
          }
        ],
        Tuesday: [
          {
            'start_time': '',
            'end_time': '',
            'start_time_model': 'tuesday-0-starttime',
            'end_time_model': 'tuesday-0-endtime'
          }
        ],
        Wednesday: [
          {
            'start_time': '',
            'end_time': '',
            'start_time_model': 'wednesday-0-starttime',
            'end_time_model': 'wednesday-0-endtime'
          }
        ],
        Thursday: [
          {
            'start_time': '',
            'end_time': '',
            'start_time_model': 'thursday-0-starttime',
            'end_time_model': 'thursday-0-endtime'
          }
        ],
        Friday: [
          {
            'start_time': '',
            'end_time': '',
            'start_time_model': 'friday-0-starttime',
            'end_time_model': 'friday-0-endtime'
          }
        ],
        Saturday: [
          {
            'start_time': '',
            'end_time': '',
            'start_time_model': 'saturday-0-starttime',
            'end_time_model': 'saturday-0-endtime'
          }
        ],
        Sunday: [
          {
            'start_time': '',
            'end_time': '',
            'start_time_model': 'sunday-0-starttime',
            'end_time_model': 'sunday-0-endtime'
          }
        ]
      }
      this.key_id = {}
    },
    inputAdd (dayindex) {

      const index = this.currrent_schedule.dates[dayindex].length
      this.currrent_schedule.dates[dayindex].push({
        'start_time': '00:00 AM',
        'end_time': '00:00 AM',
        'start_time_model': `${dayindex  }-${  index  }-starttime`,
        'end_time_model': `${dayindex  }-${  index  }-endtime`
      })
      // console.log(this.currrent_schedule.dates.monday);

    },
    inputRemove (dayindex) {

      this.currrent_schedule.dates[dayindex].splice(dayindex, 1)
    },

    initValues () {

      if (this.data.id) return
      this.dataId = null
      this.dataName = ''


    },
    submitData () {
      if (this.ExistingSchedule) {
        this.$validator.validateAll().then(result => {
          if (result) {
            const obj = {
              id: this.dataId,
              schedule: this.ScheduleModel
            }

            this.$store.dispatch('dataList/updateCamera', obj).catch(err => { console.error(err) })
            this.$emit('closeSidebar')
            this.Sibling = null
            this.initValues()
          }
        })
      }
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }

  },

  created () {
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule('dataList', moduleDataList)
      moduleDataList.isRegistered = true
    }

    this.$store.dispatch('dataList/fetchDataListSchedule')
  }

}
</script>

<style lang="scss" scoped>
.slot-actions {
  clear: both;
  text-align: right;
  margin: 5px;
}

.flatpickr-input {
  width: 50%;
}

.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
